import Constants from '../Constants';
import { LocaleData } from './LocaleData';

export default {
    _LANGUAGE: Constants.language.EN,
    WELCOME: 'Welcome to the',
    YOUR_EMAIL: 'Your email',
    PASSWORD: 'Password',
    TYPE_YOUR_EMAIL: 'Type your e-mail',
    TYPE_YOUR_PASSWORD: 'Type your password',
    ENTER: 'ENTER',
    BEGIN: 'Start',
    TERMS_OF_USE: 'Terms of Use',
    ACCEPT_TERMS: 'I have read and agree to the terms of use',
    PROCESSING: 'Loading...',
    FORGOT_PASSWORD: 'Forgot your password?',
    FORGOT_PASSWORD_TITLE: 'Forgot my password',
    FORGOT_PASSWORD_CTA1: "Keep calm! Let's define a new one!",
    FORGOT_PASSWORD_CTA2: 'Enter your email in the field below.',
    RESET_PASSWORD: 'Reset password',
    GO_BACK: 'Go back',
    AUTHENTICATION_FAILED: 'Incorrect email, password or both.',
    RESET_PASSWORD_SUCCESS: 'Password reset email sent successfully!',
    RESET_PASSWORD_FAILED: 'There was an error... Please check the email you entered and try again!',
    RESET_PASSWORD_SUCCESS_TITLE: 'We sent an email with the necessary instructions!',
    RESET_PASSWORD_SUCCESS_CTA: 'Check your email and follow the instructions to set your new password!',
    UNDERSTAND: 'Understand',
    EMPTY_ITEMS: 'No items here!',
    ITEM: 'Item',
    ITEMS: 'Items',
    LETS_START: "Let's start?",
    CREATE_NEW_ITEM: 'Create new item',
    CREATE_CATEGORY: 'Create category',
    CATEGORY_PT_BR_LABEL: 'Portuguese - PT-BR',
    CATEGORY_ING_LABEL: 'English - ING',
    CATEGORY_SPA_LABEL: 'Spanish - SPA',
    NEW_ITEM: 'New item',
    NEW: 'New',
    NEW_2: 'New',
    SELECT_MEDIA_TYPE: 'Select the media type',
    VIDEO: 'Video',
    AUDIO: 'Audio',
    ARTICLE: 'Article',
    LINK: 'Link',
    PODCAST: 'Podcast',
    SELECT_LANGUAGE: 'Select language',
    LANGUAGE: 'Language',
    LANGUAGE_PT: 'Portuguese',
    LANGUAGE_EN: 'English',
    CANCEL: 'Cancel',
    ADVANCE: 'Next',
    HEADER: 'Cover',
    DROP_FILE_HERE: 'Drop a file here or ',
    SEARCH_FILE: 'Find a file',
    ACCEPTED_IMAGE_FORMATS: '(Accepted formats: jpg and png)',
    ACCEPTED_FULL_IMAGE_FORMATS: '(Accepted formats: jpg, png, bmp e gif)',
    ACCEPTED_PNG_FORMAT: 'Accepted format: png',
    ACCEPTED_IMAGE_EXTENSIONS: '(jpg, png)',
    ACCEPTED_VIDEO_FORMATS: '(Accepted formats: mp4 and mpeg4)',
    ACCEPTED_AUDIO_FORMATS: '(Accepted format: mp3 )',
    ACCEPTED_SUBTITLE_FORMATS: '(Accepted format: vtt)',
    ACCEPTED_ZIP_FORMATS: '(Accepted format: zip)',
    ACCEPTED_ATTACHMENTS_FORMATS: '(Accepted format: pdf, ppt, xls, jpg, png, gif, mp3, mp4 and mpeg4)',
    ACCEPTED_DOCUMENT_FORMATS: '(Accepted format: pdf, doc, docx, ppt, pptx, xls, xlsx)',
    TITLE: 'Title',
    AUTHOR: 'Author',
    ESTIMATED_CONSUMPTION_TIME: 'Estimated consumption time (in minutes)',
    ESTIMATED_TIME: 'Estimated time',
    CATEGORY: 'Category',
    CATEGORIES: 'Categories',
    CATEGORY_MANAGEMENT: 'Manage the categories',
    CATEGORY_MANAGEMENT_DESCRIPTION: 'Before creating a category, make sure it already exists in the system.',
    CATEGORY_MANAGEMENT_ADD_NEW_CATEGORY: 'Create new category',
    CATEGORY_MANAGEMENT_INSERT_CATEGORY_NAME_PT: 'Enter the category name in Portuguese',
    CATEGORY_MANAGEMENT_INSERT_CATEGORY_NAME_EN: 'Enter the category name in English',
    CATEGORY_MANAGEMENT_SEARCH_BOX_PLACEHOLDER: 'Search a category',
    CATEGORY_MANAGEMENT_FILTER_INACTIVE: 'Inactive',
    CATEGORY_MANAGEMENT_LIST_EMPTY: 'There are no categories here.',
    CATEGORY_MANAGEMENT_INACTIVE_LIST_EMPTY: 'There are no inactivated categories around here.',
    CATEGORY_MANAGEMENT_SYSTEM_TOOLTIP: 'Original system category.',
    CATEGORY_MANAGEMENT_PREFIX_SUCCESS_MSG: 'The Category',
    CATEGORY_MANAGEMENT_SUFIX_SUCCESS_MSG: 'has been successfully added!',
    CATEGORY_MANAGEMENT_CATEGORY_FOUND_ERROR_MSG: 'This category already exists in the system.',
    CATEGORY_MANAGEMENT_GENERIC_ERROR_MSG: 'An error occurred while trying to create a new category.',
    CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_TITLE: 'Could not inactivate category.',
    CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_MSG:
        'One or more contents linked to this category have been identified. Remove the link before inactivating it.',
    ADD_CATEGORY: '+ Add another category',
    ACTIVATE_CATEGORY_TITLE: 'Reactivate category',
    REACTIVATE_CATEGORY_TITLE: 'Reactivate category',
    REACTIVATE_CATEGORY_MSG: 'There is an inactive category with this name. Do you want to reactivate it now?',
    ACTIVATE_CATEGORY_DESCRIPTION_PREFIX: 'The category',
    ACTIVATE_CATEGORY_DESCRIPTION_SUFIX: 'will be reactivated. Do you wish to continue?',
    INACTIVATE_CATEGORY_TITLE: 'Inactivate category',
    INACTIVATE_CATEGORY_DESCRIPTION_PREFIX: 'The category',
    INACTIVATE_CATEGORY_DESCRIPTION_SUFIX: 'will be inactivated. Do you wish to continue?',
    ACTIVATE_SUCCESS_PREFIX: 'The category',
    ACTIVATE_SUCCESS_SUFIX: 'was reactivated!',
    INACTIVATE_SUCCESS_PREFIX: 'The category',
    INACTIVATE_SUCCESS_SUFIX: 'was inactivated!',
    ACTIVATE_FAILURE_PREFIX: 'The category',
    ACTIVATE_FAILURE_SUFIX: 'was not activated!',
    INACTIVATE_FAILURE_PREFIX: 'The category',
    INACTIVATE_FAILURE_SUFIX: 'was not inactivated!',
    TAGS: 'Tags',
    CONTENT: 'Content',
    SAVE: 'Save',
    SAVE_ADD_QUESTION: 'Save and Add new question',
    COURSE_ONLINE: 'Online course',
    TEXT_COURSE_ONLINE: 'Training that can be carried out any day and at any time, without the presence of a facilitator.',
    TEXT_WORKSHOP: 'Live training, given by a facilitator and with a specific day, time and place.',
    WORKSHOP: 'Workshop',
    WORKSHOPS: 'Workshops',
    WORKSHOP_S: 'Workshop(s)',
    TYPE: 'Type',
    TYPE_HERE: 'Type here',
    TYPE_TITLE: 'Enter the title',
    SELECT_AUTHOR: 'Select the author',
    TYPE_AUTHOR: "Enter the author's name",
    MIN_PLACEHOLDER: '10 minutes',
    SELECT_CATEGORY: 'Select the category',
    TYPE_TAG: 'Enter the tag(s)',
    TYPE_TEXT: 'Type your text',
    TYPE_INTRODUCTION: 'Enter an introduction',
    URL_PLACEHOLDER: 'Enter the url here',
    INFOGRAPHIC: 'Infographic',
    REMOVE: 'Remove',
    CONTENT_TYPE: 'Content type',
    ABOUT: 'About',
    ABOUT_INSERT: 'Insert a brief description',
    VIDEO_FILE: 'Video file',
    AUDIO_FILE: 'Audio file',
    HAS_SUBTITLES: 'Does it have subtitles?',
    PRIVATE: 'Private',
    PUBLIC: 'Public',
    FILTER: 'Filter',
    SEARCH: 'Search',
    EDIT: 'Edit',
    DELETE_ITEM: 'Delete item',
    DELETE_LIST: 'Excluir playlist',
    ALPHABETICAL_ORDER: 'Alphabetical order',
    NEWLY_CREATED: 'Newly created',
    TOP_RATED: 'Top rated',
    TIME: 'Time',
    IN_MINUTES: 'In minutes',
    MEDIA_TYPE: 'Media type',
    ORDER_BY: 'Order by',
    FILTER_BY: 'Filter by',
    EMPTY_LIST: 'No lists here!',
    CREATE_NEW_LIST: 'Create new list',
    FILTER_BY_VISIBILITY: 'Filter by visibility',
    CLEAN_FILTER: 'Clean filter',
    LIST: 'List',
    CREATE: 'Create',
    CONFIRM_EXIT: 'YES, I want to EXIT',
    NO: 'No',
    YES: 'Yes',
    LEAVE_SECTION_MESSAGE: 'All the information will be deleted. Are you sure you want to exit?',
    ATTENTION: 'Attention',
    CREATE_NEW_PLAYLIST: 'Create new playlist',
    CREATED_AT: 'Created at',
    CREATED_AT_PROGRAM: 'Created at',
    LIST_ITEMS: 'List items',
    LIST_NO_ITEMS: "You don't have any items on your list yet.",
    CHOOSE_ITEMS_BELOW: 'Choose the items below.',
    LOCATE_AND_SELECT_ITEMS: 'Locate and select Items',
    WE_FOUND: 'We found',
    INCOMPATIBLE_ITEM: 'incompatible item',
    INCOMPATIBLE_ITEMS: 'incompatible items',
    WITH_SELECTED_LANGUAGE: 'with the selected language.',
    HOME_HELLO: 'Hello',
    HOME_ORGANIZATION_HAS: 'Your organization has',
    HOME_REGISTERED_USERS: 'registered users.',
    HOME_ACTIVE_USERS: 'active users.',
    EMPTY_PEOPLE: "You don't have any registered users yet!",
    CREATE_NEW_PEOPLE: 'Add new user',
    NEW_PEOPLE: 'New user',
    ACTIVE: 'Active',
    REACTIVATE_ACTION: 'Reactivate',
    INACTIVE: 'Inactive',
    INACTIVATE_ACTION: 'Inactivate',
    DELETE_ITEM_CONFIRMATION: 'Do you really want to delete the item?',
    DELETE_LIST_CONFIRMATION: 'Do you really want to delete the list?',
    DELETE_COURSE_CONFIRMATION: 'Do you really want to delete the course?',
    LIST_CREATED_SUCCESSFULLY: 'Your list was created successfully.',
    ITEM_CREATED_SUCCESSFULLY: 'Your item was created successfully.',
    ADD_ANOTHER_LANGUAGE: 'Would you like to add another language?',
    ADD_ANOTHER_LANGUAGE2: 'Add another language',
    CONFIRM_ADD_LANGUAGE: 'Yes, I want to add another language',
    PROFILE_SELECT_CTA: 'You have two profiles. Which one would you like to access?',
    CHANGE_PROFILE: 'Change access profile',
    CHANGE_PASSWORD: 'Change password',
    CHANGE_LANGUAGE: 'Change language',
    SEND_FEEDBACK: 'Send feedback',
    ACCESS_AS_ADMIN: 'Access as admin',
    ACCESS_AS_USER: 'Access as user',
    CONFIRM_CHANGES: 'Confirm changes',
    CHANGE_AND_CONTINUE: 'Change and continue',
    CURRENT_PASS: 'Current password',
    NEW_PASS: 'New password',
    REPEAT_PASS: 'Repeat new password',
    REPEAT_YOUR_NEW_PASS: 'Repeat your new password',
    CHANGE_PASS_SUCCESS: 'Password successfully changed!',
    CHANGE_PASS_FAILURE: 'Error while trying to change the password',
    WRITE_YOUR_MESSAGE: 'Write your message',
    YOUR_FEEDBACK: 'Your feedback is really important for us!',
    LISTS: 'Lists',
    AVAILABLE_SPOTS: 'Available spots',
    LEAVE: 'Leave',
    FEEDBACK_SUCCESS: 'Feedback successfully sent!',
    FEEDBACK_FAILURE: 'Error while trying to send feedback',
    HOME: 'Home',
    MINE: 'Mine',
    MINE_PAGE: {
        FAVORITES: 'Favorites',
        MY_CREATIONS: 'My creations',
        COMPLETED: 'Completed',
    },
    CONFIGURATIONS: 'Configurations',
    USERS: 'Users',
    SUPPORT: 'Support',
    ARCHIVE_ITEM: 'Archive',
    ARCHIVE_ITEMS: 'Archive',
    PUBLISHED: 'Published',
    PUBLISHED_PROGRAM: 'Published',
    DRAFT: 'Draft',
    ARCHIVED: 'Archived',
    VISIBILITY: 'Visibility',
    ADMIN_USERS: 'Manage Users',
    ADMIN_IMPORT_USERS: 'Import history',
    MAIL_FIRTS_ACCESS: 'First access email',
    MAIL_FORGOT_PASSWORD: 'Forgot password email',
    PASSWORD_REDEFINE: 'Reset password',
    PUBLISH: 'Publish',
    UNARCHIVE: 'Uncharive',
    SAVE_AND_CLOSE: 'Save and close',
    ARCHIVE_ITEM_CONFIRMATION: 'Do you really want to archive the item?',
    PUBLISH_ITEM_CONFIRMATION: 'Do you really want to publish the item?',
    UNARCHIVE_ITEM_CONFIRMATION: 'Do you really want to unarchive the item?',
    ARCHIVE_LIST_CONFIRMATION: 'Do you really want to archive the list?',
    PUBLISH_LIST_CONFIRMATION: 'Do you really want to publish the list?',
    UNARCHIVE_LIST_CONFIRMATION: 'Do you really want to unarchive the list?',
    A_PRODUCTION: 'Produced by',
    LIST_EDIT: 'List edit',
    AUDIO_TYPE_NAME: 'Podcast',
    DOCUMENT_CHANGE_LANGUAGE_LABEL: 'Text',
    DOCUMENT_TYPE_NAME: 'Article',
    HOURS: 'h',
    MINUTES: 'min',
    VIDEO_TYPE_NAME: 'Video',
    LATEST_PUBLISHED_LISTS: 'Just arrived',
    MOST_ACCESSED_LISTS: 'Trending now',
    MOST_ACCESSED_LISTS_WHITELABEL: 'Most accessed',
    IN_PROGRESS_LISTS: 'In progress',
    COMPLETED_LISTS: 'Completed',
    TOP_RATED_LISTS: 'Top rated',
    LIKE_YOU_LISTS: 'You may also like',
    SEARCH_RESULT_LISTS: 'Search results',
    OTHER_COURSES: 'Other courses',
    ORGANIZATION_NOT_FOUND_TITLE: 'Page unavailable',
    ORGANIZATION_NOT_FOUND_MESSAGE: 'This page is not available or you do not have access to it.',
    FIRST_ACCESS_EMAIL_SENT: 'First access e-mail successfully sent to:',
    LIST_OF_CATEGORIES: 'Explore categories',
    ATTACHMENTS: 'Attachments',
    ATTACHMENT: 'Attachment',
    THERE_ARE_NO_ATTACHMENTS: 'No attachments',
    FAVORITES_PAGE: 'My favorites',
    EMPTY_SECTION_MESSAGE: 'This section is empty.',
    COMPLETED_ITEM: 'Item completed successfully',
    LABEL_RATING_LESSON: 'How do you rate this content?',
    WHAT_DID_YOU_THINK: 'What are your thoughts about it?',
    SELECT_AS_MANY_OPTIONS_AS_YOU_WANT: 'Select as many options as you wish.',
    SUCCESS_REVIEW_MESSAGE: 'Item reviewed successfully!',
    SUCCESS_CLASSIFICATION_MESSAGE: 'Item rated successfully!',
    ITEM_REVIEW: 'Item review',
    SEND_REVIEW: 'Send',
    COMMENT: 'Comment',
    COMMENTS: 'Comments',
    EMPTY_COMMENTS_SECTION: 'No comments',
    ADD_COMMENT: 'Add comment',
    DURATION: 'Duration',
    COMMENT_PLACEHOLDER: 'Add your comment here...',
    SYSTEM: 'System',
    SYSTEM_CUSTOMIZATION: 'Customize the system',
    PRE_SAVED_CONTENT: 'Pre saved content',
    LABEL_RATING_COURSE: 'How do you rate this content?',
    EXTERNAL_LINK: 'External link',
    SEE_MORE_TEXT: 'Continue',
    FOR_YOU_LISTS: 'For you',
    DATE: 'Date',
    TOTAL_RECORDS: 'Total Records',
    TOTAL_PROCESSED: 'Total Processed',
    STATUS: 'Status',
    DETAILS: 'Details',
    SEE: 'See',
    IN_PROGRESS: 'In progress...',
    CONCLUDED: 'Completed',
    CONCLUDE: 'Done',
    CONCLUDED_ERROR: 'Completed with error',
    NAME: 'Name',
    EMAIL: 'Email',
    DOWNLOAD_ERRORS: 'Download errors',
    COMPLETED: 'Completed',
    BLOCKED: 'Blocked',
    FAILED: 'Failed',
    INCOMPLETE: 'Incomplete',
    NOT_ATTEMPTED: 'Not Attempted',
    COMPLETED_COURSE: 'Completed',
    PASSED: 'Passed',
    COMPLETED_WITH_ERRORS: 'Completed with errors',
    STARTED: 'Started',
    CREATED: 'Created',
    EMPTY_IMPORT_DETAIL: 'Import details empty',
    EMPTY_IMPORT_HISTORY: 'Import history empty',
    SUCCESS_WITH_EXCLAMATION: 'Success!',
    ERROR: 'Error',
    ERROR_MESSAGE: 'Error message',
    CONTENTS: 'Contents',
    ENROLLED: 'Enrolled',
    NOT_ENROLLED: 'Not enrolled',
    ENROLLED_IN_ANOTHER_CLASS: 'Enrolled in another class.',
    STUDENT_NAME: 'Student name',
    EXPIRES_IN: 'Expires in',
    EXPIRES: 'Expires',
    DAYS: 'Days',
    DAY: 'Day',
    TODAY: 'Today',
    UNTIL: 'Until',
    LABEL_RATING_PROGRAM: 'How do you rate this program?',

    COURSE_NOT_STARTED: 'Not started',
    COURSE_STARTED: 'Started',
    COURSE_EXPIRED: 'Expired',
    COURSE_PASSED: 'Passed',
    COURSE_FAILED: 'Failed',
    COURSE_BLOCKED: 'Blocked',
    COURSE_COMPLETED: 'Completed',
    PROGRAM_EXPIRED: 'Expired',

    massImport: {
        MASS_ADD: 'Mass add',
        CHOSE_FILE: 'Chose file',
        TEMPLATE: 'Model download',
        DOWNLOAD: 'People download',

        PROCESSING: 'We are processing ...',
        FEW_SECONDS: 'This operation may take a few seconds.',

        NUMBER_USERS: 'The number of users',
        EXCEEDED_LIMIT: 'has exceeded the limit of available licenses.',
        TOTAL_LICENCES: 'You have %n licenses',
        TOTAL_RECORDS: 'your spreadsheet has %n records.',
        PRECONDITION: 'Sending failed',
        PRECONDITION_REV: 'Verify if your file is correct or filled and try again',
    },

    toastMessages: {
        ADD_ITEM_TO_LIST_SUCCESS: 'Item successfully added to the list',
        ADD_ITEMS_TO_LIST_SUCCESS: 'Items successfully added to the list',
        ADD_ITEMS_TO_LIST_ERROR: 'Items successfully added to the list',
        REMOVE_ITEM_FROM_LIST_SUCCESS: 'Item successfully removed from list',
        REMOVE_ITEM_FROM_LIST_ERROR: 'There was an error while removing the item from the list. Try again',
        LESSON_SAVE_SUCCESS: 'Lesson successfully saved',
        LESSON_SAVE_ERROR: 'There was an error while saving the lesson. Try again',
        LESSON_REMOVE_SUCCESS: 'Lesson successfully removed',
        LESSON_REMOVE_ERROR: 'There was an error while removing the lesson. Try again',
        LIST_SAVE_SUCCESS: 'List successfully saved',
        LIST_SAVE_ERROR: 'There was an error while saving the list. Try again',
        CONTENT_REMOVE_SUCCESS: 'Successfully removed',
        CONTENT_REMOVE_ERROR: 'There was an error while removing. Try again',
        LIST_PUBLISHED_SUCCESS: 'Published!',
        LIST_PUBLISHED_ERROR: 'There was an error while publishing the list. Try again',
        LIST_ARCHIVED_SUCCESS: 'List successfully archived',
        LIST_ARCHIVED_ERROR: 'There was an error while archiving the list. Try again',
        PERSON_SAVE_SUCCESS: 'Person successfully saved',
        CONFIGURATION_ERROR: 'There was an error while saving the new configuration. Try again',
        CONFIGURATION_SUCCESS: 'Configuration successfully saved',
        IMPORT_HISTORY_ERROR: 'There was an error while fetching the import history. Try again',
        UPDATE_SCORM_PACKAGE_IDENTIFIER_ERROR: 'One or more package lesson identifiers (SCO) is different from the original package.',
        UPDATE_SCORM_PACKAGE_SCOS_SIZE_ERROR: 'The number of lessons (SCOs) of the package sent is different from the original package.',
        UPDATE_SCORM_PACKAGE_ERROR: 'There was an error while updating scorm package. Try again',
        FILE_TYPE_NOT_ALLOWED: 'Attention! Unsupported file. Use one of the accepted formats',
        SCORM_PACKAGE_PROCESS_SUCCESS: 'Scorm package successfully processed',
        SCORM_PACKAGE_PROCESS_ERROR: 'There was an error while processing scorm package',
        ADD_CONTENT_URL_ERROR: 'There was an error while saving the content. The Url is not valid.',
        QUESTION_REMOVE_ERROR: 'There was an error while removing the question. Try again',
        ITEM_SAVE_SUCCESS: 'Item successfully saved',
        ITEM_SAVE_ERROR: 'There was an error while saving the item. Try again',
        GROUP_SAVE_SUCCESS: 'PEDIR TRADUÇÃO',
        GROUP_SAVE_ERROR: 'PEDIR TRADUÇÃO',
    },
    onboardingWhiteLabel: {
        WELCOME_TITLE: 'Welcome to your new way of learning!',
        WELCOME_DESCRIPTION: 'Next, check out some of what you can find here.',
        PROTAGONISM_TITLE: 'Protagonism and autonomy',
        PROTAGONISM_DESCRIPTION:
            'Access different content in different formats, according to your interests and availability. Also, create playlists to consume individually or share with the network.',
        RECOMMENDATIONS_TITLE: 'Recommendations',
        RECOMMENDATIONS_DESCRIPTION:
            'Receive content indications based on your preferences, your consumption behavior and the preferences of people with profiles similar to yours.',
        VIRTUAL_PARTNER_TITLE: 'Virtual partner',
        VIRTUAL_PARTNER_DESCRIPTION:
            'Do you have any questions, want to update your learning map or want to search for content in a more personalized way? Talk to Flo! She is your partner on this learning journey.',
        FINAL_TITLE: "Now it's up to you!",
        FINAL_DESCRIPTION: 'Take advantage of everything the platform offers. Good journey!',
    },
    PORTUGUESE: 'Portuguese',
    ENGLISH: 'English',
    CHANGE_LANGUAGE_TEXT:
        '<b>Caution!</b> Make sure that you saved all additions/changes on the page. Once you confirm <b>the language change</b>, all <b>data that has not been saved will be lost.</b>',
    AVAILABLE_LANGUAGES: 'Available languages',
    ORIGINAL_LANGUAGE: 'Original',
    NON_EXISTENT_USER: 'The user does not exist. Please, check if the data is correct or contact support.',
    USER_NOT_REGISTERED: 'Your email is not registered. Try with another address or contact support.',
    SEE_MORE_COMMENTS: 'See more comments (%n)',
    LISTS_WITH_THIS_CONTENT: 'Lists that also have this content',
    LIST_WITH_THIS_CONTENT: 'List that also has this content',
    UNLIMITED: 'Unlimited',
    THE_FILE_IS_STILL_BEING_PROCESSED: 'The file is still being processed',
    NO_MATCHES_FOUND: 'No matches found',
    VIDEO_PROCESSING: 'The video is processing',
    WAIT_FEW_MINUTES: 'Wait a few minutes...',
    RECENT_SEARCHES: 'Recent searches',
    CLEAR: 'Clear',
    ADD_NEW_TAG: 'Add new Tag: ',
    REDIRECT_TO_HOME: 'Redirecting to home in %s seconds...',
    VIEWS: 'Visualizações',
    GO_TO_HOME_PAGE: 'Go to home page',
    PAGE_UNAVAILABLE: 'Page unavailable',
    TEXT_PAGE_UNAVAILABLE: 'This page is no longer available or you do not have access to it.',
    PASSWORD_CHECKLIST_UPPERLOWERCASE: 'Uppercase and lowercase letters',
    PASSWORD_CHECKLIST_CHARACTERS: '%n characters',
    PASSWORD_CHECKLIST_SPECIAL_CHARACTERS: 'Special character',
    PASSWORD_CHECKLIST_HAS_NUMBERS: 'Number',
    PASSWORD_CHECKLIST_TITLE: 'Your password must contain at least:',
    PASSWORD_CHECKLIST_SPECIAL_CHAR_EXAMPLES: 'Example: # ! @ & * $ =',
    PASSWORD_AND_CONFIRMATION_NOT_EQUAL: "Passwords don't match.",
    INVALID_PASSWORD_FORMAT: 'Invalid password format',
    INCORRECT_CURRENT_PASSWORD: 'Incorrect current password',
    SAME_TITLE_IN_ANOTHER_RESULT: 'This title was already inputted in another result.',
    NOTIFICATION_ALL: 'All',
    NOTIFICATION_UNREAD: 'Unread',
    WEEKS: 'weeks',
    NEWLY_ADDED: 'Newly added',
    OPS: 'Ops!',
    ERROR_WHILE_SAVE_DATA: 'Seems like there is a problem with saving your data.',
    TRY_AGAIN: 'Try again',
    ITEM_ADDED_TO_LIST: 'Item added to the list.',
    CHANGE_ITEM_LANGUAGE: 'Change item language',
    ADD_TO_MY_LISTS: 'Add to my lists',
    SELECT_LISTS: 'Select a list',
    CHANGE: 'Change',
    MY_LISTS_EMPTY_SECTION: 'You have not yet created private lists',
    INSERT_LIST_NAME: 'Enter a name for the list',
    LIST_NAME: 'List name',
    LEAVE_ACTION_MESSAGE: 'Do you want to cancel?',
    LEAVE_ACTION_WARNING: 'You will be canceling the action when you confirm.',
    COURSE_HAS_CONTENT_ERROR: 'You cannot select a list that already contains the item.',
    AVAILABLE_TO_ALL_ORGANIZATIONS: 'Allow all organizations to view published content.',
    LMS: 'LMS',
    PLAYLIST: 'Playlist',
    BUZZ: 'Buzz',
    COURSES: 'Courses',
    PROGRAMS: 'Programs',
    PROGRAM: 'Program',
    CREATE_NEW_COURSE: 'Create new course',
    CREATE_NEW_PROGRAM: 'Create new program',
    CREATE_NEW_TEST: 'Create new test',
    NEW_COURSE_SCORM_ALERT:
        'This is the only moment to add a scorm package. If you choose to proceed or save this page, you will no longer be able to add the file. Do you want to continue?',
    COURSE_PUBLISH: 'Your course has been successfully published!',
    ATTENTION_COURSE_PUBLISHED:
        'Your course can now be used to create programs. Would you like to add a class now and make the course available separately on the platform?',
    CONFIRM_INSERT_SCORM: 'No, Insert SCORM',
    EMPTY_COURSE_LIST: 'No courses here!',
    EMPTY_PROGRAM_LIST: 'No programs here!',
    EMPTY_TEST_LIST: 'No tests here!',
    STEP_OF: 'step %n of %t',
    NEXT: 'Next',
    PREVIOUS: 'Previous',
    SAVE_TO_DRAFT: 'Save to draft',
    GENERAL_INFORMATION: 'General information',
    MEDIA_VIDEO_ALERT: "We'll update automatically after upload the video media.",
    ARTICLE_CONTENT: "Article's content ",
    MEDIA_MINUTES_ALERT: "We'll update automatically after upload the %s media.",
    LESSONS: 'Lessons',
    CLASSES: 'Classes',
    CLASS: 'Class',
    CLASSES_LIST: 'List of Classes',
    EMPTY_COURSE_CLASS_LIST: 'There is no class available!',
    CREATE_NEW_COURSE_CLASS: 'Use the menu on the side to add the first class of this course',
    NEW_COURSE: 'New Course',
    EDIT_COURSE: 'Course Edition',
    NEW_PROGRAM: 'New Program',
    EDIT_PROGRAM: 'Program Edition',
    DELETE: 'Delete',
    ADD_A_HEADER: 'Add a cover image',
    HAS_PREREQUISITE: 'Has prerequisite.',
    ITS_MANDATORY: 'Required.',
    SAVE_HIGHEST_SCORE: 'Save highest score',
    EVALUATION_BLOCKED_AFTER_APPROVAL: 'Block after approval',
    QUESTION_ALTERNATIVES_RANDOM_ORDER: 'Display alternatives randomly',
    SHOW_ANSWERS_AT_THE_END: 'Show feedback after completing evaluation',
    MINIMUM_SCORE_FOR_APPROVAL: 'Mininum score for approval',
    START_EVALUATION: 'Start evaluation',
    EVALUATION_WEIGHT: 'Evaluation weight (Weighted average)',
    INC_EVALUATION_WEIGHT: 'Include weight',
    INC_NUMBER_ATTEMPTS: 'Limit attempts',
    INC_TIME_LIMIT: 'Define time limit',
    WRITE_CONTEXT_HERE: 'Write your statement here',
    CONTEXT_QUESTION: 'Statement of the question',
    ADD_QUESTIONS: 'Add questions',
    ADD_QUESTION: 'Add question',
    EDIT_QUESTION: 'Edit question',
    SAVE_EDITIONS: 'Save editions',
    QUESTION_STATEMENT: 'Enter a statement for the question',
    QUESTION_SAVE_SUCCESS: 'Question successfully saved!',
    DELETE_QUESTION_MESSAGE: 'You will remove this issue from your list. This action cannot be reversed. Do you want to continue anyway?',
    QUESTION_RETURN_MESSAGE: 'You will return to the lesson board and lose all unsaved information. Do you want to continue anyway?',
    ALTERNATIVE: 'Alternative',
    ADD_ALTERNATIVES_CHECK_CORRECT: 'Add the alternatives and check the correct one',
    ADD_ALTERNATIVE: 'Add alternative',
    SELECT_CORRECT_ALTERNATIVE: 'Select the correct alternative',
    SELECT_CORRECT_ALTERNATIVES: 'Select the correct alternatives',
    DELETE_ALTERNATIVE_MESSAGE: 'The question must have at least two alternatives',
    BLANK_ALTERNATIVES: 'There are blank alternatives',
    NUMBER_OF_ATTEMPTS_ALLOWED: 'Number of attempts',
    TIME_LIMIT: 'Time to run',
    TOOLTIP_HAS_PREREQUISITE: 'This lesson will only be available after the completion of the previous one, marked as required.',
    TOOLTIP_ITS_MANDATORY: 'This lesson needs to be completed to complete the course.',
    TOOLTIP_EVALUATION_BLOCKED_AFTER_APPROVAL: 'Blocks the evaluation after the user is approved',
    TOOLTIP_QUESTION_ALTERNATIVES_RANDOM_ORDER: "Display question's alternatives in a random order for each user.",
    TOOLTIP_SHOW_ANSWERS_AT_THE_END: 'Shows right and wrong answers at the end of evaluation.',
    TOOLTIP_EVALUATION_WEIGHT: 'Defines an evaluation weight when the course has 2 or more evaluations.',
    TOOLTIP_EVALUATION_MASTERYSCORE: 'Set a value in the range 10 to 100',
    TOOLTIP_NUMBER_OF_ATTEMPTS_ALLOWED: 'Maximum number of attempts the user will have to take the evaluation.',
    TOOLTIP_TIME_LIMIT: 'Maximum time, in minutes, the user will have to take the evaluation.',
    TOOLTIP_TAGS: 'The tags are inherited from the course, you can edit them if you need to.',
    TOOLTIP_CATEGORY: 'The categories are inherited from the course, you can edit them if you need to.',
    TOOLTIP_ITS_MANDATORY_TRAINING: 'Check if this is a mandatory completion training for this class.',
    OPTIONAL_INFO: 'Optional information',
    VISUALIZE: 'Visualize',
    NO_TITLE: 'No title',
    NO_DESCRIPTION: 'No description',
    DEFAULT_AUTHOR: 'No author',
    LESSON_BOARD: 'Lesson board',
    LESSON_NOT_STARTED: 'Not started',
    EVALUATION: 'Evaluation',
    EVALUATIONS: 'Evaluations',
    ATTEMPTS: 'Attempts',
    ATTEMPT: 'Attempt',
    MASTERY_SCORE: 'Mastery score',
    SCORE: 'Score',
    EVALUATION_TIPS_1: 'You are about to start the evaluation. For a better experience, we request you to follow some good habits:',
    EVALUATION_TIPS_2: 'When you start the evaluation, please navigate all the way through the end answering the questions.',
    EVALUATION_TIPS_3: 'Do not stay away from the computer with the ongoing evaluation.',
    EVALUATION_TIPS_4: 'Do not close the evaluation to resume it later. It will count as one try, even if it is not finished.',
    EVALUATION_TIPS_5: 'Take some time to answer the evaluation without any interruptions.',
    QUESTIONS: 'Questions',
    QUESTION: 'Question',
    QUESTIONS_ANSWERED: 'Questions answered',
    QUESTION_ANSWERED: 'Question answered',
    KNOWLEDGE_EVALUATION: 'Knowledge Evaluation',
    EXIT_EVALUATION: 'Exit evaluation',
    EXIT_EVALUATION_TITLE: 'You are leaving the evaluation!',
    EXIT_EVALUATION_CONFIRMATION: 'When you click on exit, the evaluation will end and you will lose the attempt. Do you want to proceed?',
    SELECT_ALTERNATIVE: 'Select an alternative',
    BACK_COURSE: 'Back to course',
    OF: 'of',
    QUESTION_NAVIGATION_CLICK: 'Click on the numbers to go to a specific question.',
    ANSWERED_QUESTION_HIGHLIGHTED: 'The answered questions are highlighted.',
    SCORM_SCO_WARNING:
        'Before uploading a new SCORM package, make sure that the number of lessons (SCOs) and their identifiers is the same as the original package.',
    COURSE_DESCRIPTION: 'Course Description',
    INSERT_DESCRIPTION_TO_HELP: 'Enter a description that helps the student understand the course content.',
    SCORM_PACKAGE: 'Scorm package',
    SCORM_PACKAGE_ALERT: 'Attention! Here is the only moment to upload SCORM packages.',
    REMOVE_PACKAGE: 'Remove package',
    UPDATE_PACKAGE: 'Upload package with update',
    LESSON: 'Lesson',
    LOADING: 'Loading...',
    LESSON_DESCRIPTION_DISABLED_INFO: 'We’ll update automatically after inserting the link',
    EMPTY_LESSON_BOARD_TITLE: 'Your lesson board is still empty!',
    EMPTY_LESSON_BOARD_MESSAGE: 'Use the menu on the side to add some lessons.',
    EMPTY_LESSON_COMMENT: 'Click here to access the lesson.',
    EMPTY_QUESTION_BOARD_TITLE: 'No question has been added to this evaluation',
    ALL_N_STUDENTS_ENROLLED: 'All %n students enrolled',
    SCORM_PACKAGE_IN_PROCESS: 'Processing scorm package...',
    CLASS_TITLE: 'Class title',
    CLASS_TITLE_PLACEHOLDER: 'Enter a name for the class',
    CLASS_ID: 'Class ID',
    CLOSED: 'Closed',
    ENROLLED_LIST: 'enrolled',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    UNDEFINED: 'undefined',
    ENROLL_CONFIG: 'Enroll configurations',
    ENROLL_NAME: 'Class name',
    CLOSED_CLASS: 'Closed class',
    ENROLLMENT: 'Enrollments',
    ENROLL: 'Enroll',
    ENROLLED_STUDENTS: 'enrolled people',
    ENROLLED_STUDENT: 'enrolled person',
    SHOW_ALL: 'Show all',
    VIEW_ALL: 'View all',
    CLEAN_CLASS: 'Clean class',
    ENROLL_STUDENTS: 'Enroll individually',
    MASS_ENROLL_STUDENTS: 'Batch enrollment',
    DEADLINE: 'Deadline',
    CLASS_PERIOD: 'Class period',
    CLASS_PERIOD_TITLE: 'Class period',
    REALIZATION_OF_WORKSHOP: 'Meeting(s)',
    FROM: 'From',
    TO: 'To',
    START: 'Start',
    END: 'End',
    CHOOSE_START_DATE: 'Choose a start date',
    CHOOSE_END_DATE: 'Choose an end date',
    END_DATE_INFO: 'End date setting is optional',
    CERTIFICATE: 'Certificate',
    AVAILABLE_ON_FINISH: 'Available at the end',
    CERTIFICATE_PREVIEW: 'Preview standard certificate',
    CERTIFICATE_PREVIEW_TITLE: 'Standard certificate',
    SEARCH_FOR_STUDENT: 'Search for students names',
    SEARCH_FOR_COURSE: 'Search for course',
    SHOW_CATEGORY_COURSE: 'Showing Category Courses:',
    ADD_COURSE: 'Add',
    COURSE: 'Course',
    CERTIFICATE_ALERT: 'A standard system certificate will be issued.',
    PROGRAM_CERTIFICATE_ALERT: 'A standard system certificate will be issued. Open programs do not issue certificate',
    READ_MORE: 'Read more',
    READ_LESS: 'Read less',
    BY: 'By',
    SET_FULL_SCREEN: 'Fullscreen',
    UNSET_FULL_SCREEN: 'Back',
    SCORM_PACKAGE_PROCESSING_ALERT:
        'The Scorm package is still being processed and it may take a while. This course is already saved in the draft tab. In a few moments try to publish it again.',
    SCORM_PACKAGE_PROCESSING_ERROR_ALERT:
        'We found an error in processing the Scorm package. Go to the General Information tab and try to upload again.',
    DOWNLOAD_CERTIFICATE: 'Download the certificate',
    COMPLETED_COURSE_MESSAGE: `Congrats, you've already completed this course!`,
    COMPLETED_PROGRAM_MESSAGE: "Congrats, you've already completed this program!",
    WITH_CERTIFICATION: 'With certification',
    WITH_CERTIFICATE: 'With certificate',
    PROGRAM_WITH_CERTIFICATE: 'Program with certificate',
    FINISH: 'Finish',
    REQUIRED_FIELDS: 'required fields',
    PROGRAM_STATUS_HINT: 'Set the status closed if your program will not receive changes and if your classes need to generate certificates.',
    INSERT_PROGRAM_DESCRIPTION_TO_HELP: 'Enter a description that helps the student understand the program content.',
    PROGRAM_STATUS_OPEN: 'Open program',
    PROGRAM_STATUS_CLOSE: 'Closed program',
    PROGRAM_DESCRIPTION: 'Program Description',
    PROGRAM_CONTENT: 'Program Content',
    PROGRAM_PUBLISH_MODAL_TITLE: 'Your program was created successfully!',
    PROGRAM_PUBLISH_MODAL_SUBTITLE: 'Would you like to add a class now?',
    QUESTIONNAIRE_RESULTS: {
        PASSED_MSG: 'Congratulations',
        NOT_PASSED_MSG: 'Too bad',
        YOU_WERE: 'You have been',
        MALE_APPROVED: 'Approved',
        FEMALE_APPROVED: 'Approved',
        MALE_NOT_APPROVED: 'Reproved',
        FEMALE_NOT_APPROVED: 'Reproved',
        MESSAGE_LINE_1: 'You needed {0}% and scored {1}%',
        MESSAGE_LINE_2: 'Check out the answers on the right side.',
        RESPONSE_SUMMARY: 'Summary Response',
        TRY_AGAIN: 'Try again',
        BACK_TO_COURSE: 'Back to course',
        YOU_STILL_HAVE_X_ATTEMPTS: 'You still have %n attempts left!',
        DO_YOU_WANT_TO_RETRY: 'Do you wish to retry?',
        DO_YOU_WANT_TO_GO_BACK_TO_COURSE: 'Do you wish to go back to the course?',
    },
    ONBOARDING: {
        MAKE_ME_QUESTIONS: 'Me faça perguntas',
        MAKE_ME_QUESTIONS_DESCRIPTION: 'Clique no botão Flô para falar comigo. Posso tirar suas dúvidas ou só bater um papo!',
        SMART_SEARCH: 'Busca inteligente',
        SMART_SEARCH_DESCRIPTION: 'Tentando achar algo específico? A busca não ajudou? Fale comigo e receba uma recomendação mais do que certeira!',
        LEARNING_MAP: 'Mapa de aprendizagem',
        LEARNING_MAP_DESCRIPTION: 'Trace uma meta de estudos e acompanhe seu progresso. Estarei aqui trazendo lembretes, incentivos e dicas!',
        TOPICS_OF_INTEREST: 'Temas de interesse',
        TOPICS_OF_INTEREST_DESCRIPTION: 'Esses são os temas atuais da plataforma. Marque quais você prefere:',
        BOT_YOU_HERE: 'Você por aqui?!',
        BOT_IM_CALLED: 'Olá! Me chamo',
        BOT_NAME: 'Flô',
        BOT_WHO_I_AM: 'Assistente virtual ou guia extra-dimensional?',
        BOT_HOW_CAN_I_HELP_YOU: 'Clique e veja como posso ajudar!',
        BOT_LETS_GO: 'Vamos lá',
        ACKNOWLEDGEMENT: 'Combinado!',
        ACKNOWLEDGEMENT_FEEDBACK: 'Cada feedback ajuda a melhorar a precisão com que os conteúdos são recomendados para você!',
        ACKNOWLEDGEMENT_REMINDER: 'Lembre-se: se quiser alterar seus Temas de Interesse, acesse as configurações em seu perfil.',
    },
    LEARNING_MAP: {
        WEEKLY_TIME_AVAILABLE: 'Tempo disponível para estudo semanal',
        FAVORITE_MEDIA: 'Mídias preferidas',
        LEARNING_ITEMS_CHARACTERISTICS: 'Características dos itens de aprendizagem',
        GET_SUGGESTIONS_BY_EMAIL: 'Receber sugestões de itens por e-mail',
        TIME_OF_THE_DAY_TO_GET_SUGGESTIONS: 'Você prefere receber dicas em qual período',
        LEARNING_MAP_EDIT_OVERWRITE_MESSAGE: 'Ao alterar os dados desta tela, os dados atuais da sua meta serão sobrepostos.',
        LEARNING_MAP_SUCCESS_ON_SAVE: 'Mapa de aprendizado salvo com sucesso!',
        LEARNING_MAP_FAIL_ON_SAVE: 'Erro ao salvar mapa de aprendizagem. Por favor, tente novamente.',
        MORNING: 'Morning',
        AFTERNOON: 'Afternoon',
        EVENTING: 'Evening',
        GOAL: 'Meta',
        WEEKLY_GOAL: 'Meta semanal - até',
        MINUTES: 'Minutos',
        COMPLETED_ITEMS: 'itens concluídos',
        COMPLETED_ITEM: '1 item concluído',
    },
    VIEW_MY_PROFILE: 'View my profile',
    PROFILE_MENU: {
        TOPICS_OF_INTEREST: 'Temas de interesse',
        LEARNING_MAP: 'Mapa de Aprendizagem',
        CONFIGURATIONS: 'Configurações',
    },
    HELP_REFINE_RECOMMENDATIONS: 'Hey, me ajude a refinar ainda mais as minhas recomendações.',
    HELP_REFINE_RECOMMENDATIONS_EXPLANATION:
        'Você poderá alterar seus temas de interesse a qualquer momento. Após selecionar os temas, não esqueça de salvar as alterações.',
    SAVE_ITEMS_LIST_CONFIRMATION: 'Do you wish to save the new items added to the list?',
    TOOLTIP_PROGRAM_COURSE_ITS_MANDATORY: 'This course must be completed to complete the program.',
    USE_PROGRAM_COURSE_SEQUENCE_AS_PREREQUISITE: 'Use each content of this sequence as a prerequisite for the next.*',
    PREREQUISITE_RULE_EXCEPTION: '* This rule does not include workshops.',
    PROGRAM_COURSE_LIST_EMPTY_STATE: "You haven't added any course or evaluation to the program yet.",
    PROGRAM_COURSE_LIST_EMPTY_STATE_INSTRUCTION: 'Use the menu on the side to add some.',
    CLICK_TO_DOWLOAD_APP: 'Click here to download the app',
    CLICK_TO_ACCESS_APP: 'Click here to access the app',
    SHOW_LESSONS: 'Show lessons',
    HIDE_LESSONS: 'Hide lessons',
    PUBLISHED_AND_CLOSED_PROGRAM_INFO: 'This program is already published and defined as closed. You cannot add or remove content.',
    BOT_AVAILABILITY: 'Sempre Disponível',
    BOT_GREETINGS: 'Olá',
    BOT_HOW_CAN_I_HELP_YOU_CHAT: 'No que eu posso te ajudar?',
    BOT_NAME: 'Flô',
    BOT_TYPE_YOUR_QUESTION: 'Digite a sua pergunta',
    BOT_CATEGORIES_SELECTED: 'categoria selecionada',
    LEARNING_GOAL: 'Meta de Aprendizado',
    WEEKLY: 'Semanal',
    BOT_CHIPS_SEND: 'Enviar',
    MORNING: 'Morning',
    AFTERNOON: 'Afternoon',
    NIGHT: 'Night',
    NEW_QUIZ: 'New Test',
    EDIT_QUIZ: 'Test Edition',
    QUIZ_RESULTS_TITLE: "Let's start by defining the results",
    QUIZ_RESULTS_DESCRIPTION: 'Enter what will be the final test results below. It makes easier to create responses that are linked to the results.',
    INTRODUCTION: 'Introduction',
    INTRODUCTION_TIP: 'In this field, you can enter an introduction to the result',
    RESULT: 'Result',
    RESULTS: 'Results',
    NEW_QUIZ_RESULT: 'New result',
    REMOVE_RESULT: 'Remove result',
    ADD_TIP: 'Add tip',
    TIP: 'TIP',
    TEXT: 'Text',
    IMAGE: 'Image',
    GENERAL_DATA: 'General data',
    DESCRIPTION: 'Description',
    INSERT_QUIZ_DESCRIPTION_TO_HELP: 'Insert a description explaining about the test',
    OPEN_WHEN_ACCESSING_APPLICATION: 'Open automatically when accessing the application',
    COMMUNICATE_USERS: 'Do you want to communicate users?',
    SEND_NOTIFICATION_WHEN_QUIZ_PUBLISHED: 'Send a notification about the test once it is published?',
    ENTER_HERE_THE_RESULT: 'Enter here the result',
    ENTER_HERE_THE_DESCRIPTION_RESULT: 'Enter here the description of the result',
    ENTER_HERE_THE_TIP_TEXT: 'Enter here the tip text',
    SHOW_VALUE: 'Show Value',
    USERS_ENGAGE_MORE: 'Users engage more if they think will have some benefit participating in your search!',
    I_GOT_IT: 'Ok',
    INCREASE_ENGAGEMENT: 'Increase the engagement!',
    INCREASE_ENGAGEMENT_DESCRIPTION:
        'When the user accesses the application, the test will be already open, which increases the chances of being answered.',
    WHEN_THIS_TEST_SHOULD_APPEAR: 'When this test should appear?',
    YOU_ALREADY_HAVE_A_TEST_AUTOMATICALLY_OPENING_IN_THE_APPLICATION: 'You already have a test automatically opening in the application:',
    ONLY_ONE_TEST_CAN_BE_OPENED_AUTOMATICALLY_AT_A_TIME: 'Only one test can be opened automatically at a time.',
    BACK: 'Back',
    FORWARD: 'Next',
    LAST_UPDATE: 'Última atualização: %s',
    SET_A_LEARNING_GOAL: 'Defina uma meta de aprendizado',
    LEARNING_GOAL_DESCRIPTION: 'Você pode inserir uma meta de tempo que deseja dedicar ao aprendizado por semana.',
    RATING_CONTENT_INSTRUCTION: 'Click on the amount of the stars that represents your rating.',
    UNDERSTAND_YOUR_GOAL: 'Entenda sua meta',
    GOAL_HOW_TO_SUMMARY: 'Para atingir sua meta, você precisa concluir itens e lições. Saiba como:',
    GOAL_HOW_TO_ITEMS_DESCRIPTION: '<b>Itens:</b> clique em Concluir, na barra inferior, após ver todo o conteúdo;',
    GOAL_HOW_TO_LESSONS_DESCRIPTION: 'Lições em <b>artigos, vídeos e áudios:</b> consuma 70% do conteúdo;',
    GOAL_HOW_TO_EXTERNAL_LESSONS_DESCRIPTION: 'Lições em <b>link externo:</b> acesse o link.',
    GOAL_HOW_TO_CONCLUSION: 'Se sua meta não mudar imediatamente, não se preocupe! A atualização pode demorar algumas horas.',
    HISTORY_OF_THE_LAST_4_WEEKS: 'Histórico das últimas 4 semanas',
    WEEK_ONE: 'semana 1',
    WEEK_TWO: 'semana 2',
    WEEK_THREE: 'semana 3',
    WEEK_FOUR: 'semana 4',
    STUDY_TIME: 'Tempo de estudo',
    GOAL_OF_THE_WEEK: 'Meta da semana',
    MOST_VIEWED_CATEGORIES: 'Categorias mais vistas',
    NEW_LIST: 'New list',
    WHAT_TRAINING_DO_YOU_WANT_TO_CREATE: 'What training do you want to create?',
    TITLE_OF_YOUR_LIST: 'Title of your list',
    TYPE_THE_TITLE: 'Type the title',
    SHORT_DESCRIPTION: 'Short description',
    TYPE_TAGS: 'Type the tags',
    TAGS_INFO: 'The tags help other users to find your list',
    SUGGESTED_TAGS: 'Suggested tags',
    WOULD_YOU_LIKE_TO_ADD_CONTENTS_NOW: 'Would you like to add contents now?',
    SECTION_ACCORDION_SHOW: 'Show',
    SECTION_ACCORDION_SHOW_ALL: 'Show all',
    SECTION_ACCORDION_HIDE: 'Hide',
    OK_GOT_IT: 'Ok, I got it',
    ESSENTIAL_SECTION: {
        ESSENTIAL: 'Essential',
        ESSENTIALS: 'Essentials',
        ESSENTIAL_TRAINING: 'Essential Training',
        ESSENTIAL_TRAININGS: 'Essential Trainings',
        BANNER_TITLE: 'Don’t leave it for later!',
        BANNER_INFO: "The trainings below are <b>mandatory</b>. Don't forget to do them, as they are very important!",
        ABOUT_TO_EXPIRE: 'about to expire',
        MANY_ABOUT_TO_EXPIRE: 'about to expire',
    },
    MEDIAS: 'Mídias',
    HTML_TYPE_NAME: 'Article',
    RATING_INSTRUCTION: 'Click on the amount of stars that represents your rating.',
    INTERESTS_EDITION_SAVE_SUCCESS: 'Temas de interesse salvos com sucesso!',
    REMOVE_QUESTION: 'Remove question',
    ADD_QUESTIONS_FOR_TEST: 'Add questions to the test',
    ANSWER: 'Answer',
    LESSON_STATEMENT: 'Lesson statement',
    NEW_QUESTION: '+ New Question',
    BELONGS_TO_RESULT: 'It belongs to the result',
    ENUNCIATION: 'Enunciation',
    QUESTION_DESCRIPTION_IN_USE: 'Lesson statement already in use',
    SELECT_ONE_OPTION: 'Select an option',
    ENTER_HERE_THE_DESCRIPTION_QUESTION: 'Enter here the answer option',
    WHY: 'Why',
    GOT_IT: 'Ok, I got it',
    DISTRIBUTE_ANSWERS_PROPORTIONALLY: 'Distribute answers proportionally',
    EACH_RESULT: 'For each result, enter a number equal or very close to answers',
    QUIZ_QUESTION_HINT: `<p>The number of answers that lead to each results shall be the same, so that your test has an unbiased.</p>

<p>
  For example: <br/>
  Your test has 9 questions (<b>18 replies</b>) and <b>3 results</b>. This means that
  <b>each of the results must be linked to 6 answers</b>
</p>`,
    RESULTS_WITHOUT_QUESTION: 'The following result(s) does(do) not bound to any answer:',
    ADD_MORE_QUESTIONS_FOR_RESULTS: `<p><b>Add more questions </b>so that all results are included in the responses.</p>`,
    BOT_LIKE_CONTENT_ADD_FAVORITE: 'Gostou? Quer adicionar o item a seus favoritos?',
    SUGGESTED_CONTENTS: {
        ADD_CONTENTS: 'Add items',
        NO_CONTENTS_ADDED: 'No contents added',
        WE_SELECTED_SOME_CONTENTS_FOR_YOU: "Add the items we've selected for you or search for others.",
        YOU_CAN_ALSO_ADD_MORE_CONTENTS: "Add the items we've selected for you or search for others.",
    },
    ADD: '+ Add',
    ADDED_ITEM: 'Added',
    ADDED_ITEMS: 'Added',
    NO_RESULTS_FOR_SEARCH: 'There are no results for the search',
    MANAGE: 'Manage',
    REGISTERED: 'Registered',
    AVAILABLE: 'Available',
    LICENCES: 'Licences',
    EDIT_LIST: 'Edit list',
    CONFIRM_MYLIST_DELETION: 'Do you want to delete your list?',
    WARN_ON_DISCARD_CHANGES: 'Changes will be discarded.',
    WANT_TO_PROCEED: 'Do you want to proceed?',
    UPDATE_MYLIST_ERROR: 'Oops! Seems like there is a problem with saving your data',
    MANAGE_ITEMS: 'Manage items',
    CONFIRM_DELETION_ATTACHMENT_MESSAGE: 'Do you want to delete the attachment',
    RENAME: 'Rename',
    RENAME_ATTACHMENT: 'Rename attachment',
    NEW_ATTACHMENT_NAME: 'New attachment name',
    SAVE_EDITION: 'Save Edition',
    NO_RESULTS_FOUND: 'No results found.',
    ATTACHMENTS_AFTER_SAVING_LESON: 'You will be able to add attachments after saving the lesson.',
    ORDER_ATTACHMENTS_UPLOADED_MESSAGE: 'The order in which attachments are uploaded will reflect the order in which they appear to the student.',
    GENERAL: 'General',
    MANAGE_CLASSES: 'Manage classes',
    LIST_CREATED: 'List created!',
    TEXT_ACCESS_MY_CREATIONS: 'Access <strong>Mine, My creations</strong> section to see your list.',
    CHANGE_VISIBILITY: 'Select visibility:',
    ONLY_ME: 'Only me',
    EVERYONE_IN_MY_ORGANIZATION: 'All the people in my organization',
    CHANGE_VISIBILITY_PUBLIC_ALERT:
        'When you make your list <b>Public</b>, you won’t be able to remove items from it, even if you change the visibility to <b>Private</b> again. You will only be able to add new items or delete the list.',
    FULL_NAME: 'Full name',
    DISPLAY_NAME: 'Display name',
    ABOUT_ME: 'About me',
    POSITION: 'Position',
    EDIT_PROFILE: {
        EDIT_PROFILE: 'Edit profile',
        DISPLAY_NAME_INFO:
            'The name displayed can be your first name or a nickname. Think about how you want people to find you on the platform. If this field is left blank, your full name will be displayed.',
        COMPANY_CHANGE_INFO: 'You may request your company HR to change any information.',
    },
    SUCCESS_ON_SAVE: 'Successfully saved changes!',
    UPDATE_PHOTO: 'Update photo',
    USER_REGISTRATION: 'User Registration',
    TYPE_FULL_NAME: 'Type full name',
    TYPE_EMAIL: 'Type the email',
    TYPE_POSITION: 'Type the position',
    DEPARTMENT: 'Department',
    TYPE_DEPARTMENT: 'Type the departament',
    TYPE_CPF: 'Type the CPF',
    ERROR_REGISTER: 'Error register',
    GENERIC_CONTACT_SUPPORT: 'Contact <strong>suporte.flow@afferolab.com.br</strong> and report the error <strong>[%s]</strong>.',
    LABEL_RATING_LMS_COURSE: 'How do you rate this course?',
    PUBLISHED_CONTENTS: 'Published contents',
    NO_CONTENTS_YET: 'There are no contents yet',
    ACHIEVEMENTS: {
        ACHIEVEMENTS_TITLE: 'Achievements',
        YOUR_CURRENT_PROGRESS_IS: 'Your current progress is',
        AVAILABLE_UNTIL: 'Available until',
        GRANTED_IN: 'Conquered in',
        ACCESS_CERTIFICATE_AUTHENTICITY: 'Access certificate of authenticity',
        ACCESS_ACHIEVEMENTS: 'Access Achievements',
        DOUBTS: 'Dúvidas',
        NEWS: {
            TITLE_STEP_INTRODUCTION: 'Hi!',
            TITLE_STEP_ONE: 'Achievements in Flow',
            TITLE_STEP_TWO: 'Badge',
            TITLE_STEP_THREE: 'Token',
            TITLE_STEP_FOUR: 'Rules and Deadlines',
            TITLE_STEP_FIVE: 'So, did I pique your curiosity? Get on board with us!',

            SUBTITLE_STEP_INTRODUTIONS: 'I came to tell you something new: now you can collect achievements while learning!',
            SUBTITLE_STEP_ONE:
                'To accelerate your learning journey, we brought missions that, when completed, will become achievements! Your efforts will be rewarded with badges and tokens.',
            SUBTITLE_STEP_TWO: 'Is a local achievement, linked to our Flow community. The badge currently available is the <b>In Area</b>.',
            SUBTITLE_STEP_THREE:
                'It is a digital certificate registered by our partner Hathor, Specialized in Blockchain. When you win the token, you have a permanent registration, being able to view it and start it with your professional network. The tokens available are <b>No Flow</b>, <b>Curatorship</b> and <b>Connectivity</b>.',
            SUBTITLE_STEP_FOUR:
                'By clicking on each badge or token, you can check the mission rules. Pay attention to the deadlines for the achievements so as not to miss any of them!',
            BOT_LETS_GO: 'Vamos lá',
        },
    },

    BANNER_ORG_FOR_HOME_LABEL: 'Banner for home page',
    LOGO_ORG_LABEL: 'Organization logo',
    MAX_SIZE: 'Maximum size',

    CLOSE: 'Close',
    FOLLOW: 'Follow',
    FOLLOWING: 'Following',
    FOLLOWER: 'Follower',
    FOLLOWERS: 'Followers',
    DATA_PAGE: {
        DATA: 'Data',
        DASHBOARD: 'Dashboards',
        REPORTS: 'Reports',
        GENERATE: 'Generate',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        CONFIRM: 'Confirm',
        REPORT_IN_PROCESS: 'Processing report...',
        REPORTING_HISTORY: 'Access history',
        GENERATED_ON: 'Generated in {0} {1}',
        ERROR: 'Error!',
        DEFINE_THE_DATA_PERIOD: 'Define the data period',
        GENERATE_SUCCESS_MESSAGE: 'The report will be available soon.',
        GENERATE_ERROR_MESSAGE: 'An error occurred while processing the data.',
        HISTORY: 'History',
        HISTORY_ALERT: 'Attention! The last 5 generated reports will be stored.',
        REPORT_PERIOD_MSG: 'Report period {0} - {1}',
        GENERATED_ERROR: 'On {0} at {1}',
        TRY_AGAIN: 'Try again',
    },
    REVIEW: 'Review',
    TOOLTIP_MARK_AS_DONE: 'Mark as done to add this content to the <b>Mine</b> section and receive more recommendations on this topic',
    MARK_AS_DONE: 'Mark as done',
    WHY_SHOULD_I_MARK_IT_AS_DONE: 'Why should I mark it as done?',
    FAVORITE: 'Favorite',
    GENERAL_SETTINGS: 'General settings',
    THE_SCREEN_WILL_REFRESH_IN: 'The screen will refresh in',
    CLASS_TOTAL_RECORDS: 'Total records',
    SUCCESS: 'Success',
    FAILURE: 'Failure',
    OPEN: 'Open',
    PROCESSING_IMPORT: 'Processing',
    IMPORT_COMPLETED: 'Processed',
    IMPORT_COMPLETED_WITH_ERROR: 'Processed with errors',
    CURRENT_PAGE: 'Current page',
    ITEMS_PER_PAGE: 'Items per page',
    SYSTEM_LANGUAGE: 'System language',
    SYSTEM_LANGUAGE_INFO: 'Select the language for system buttons, texts and messages.',
    CONTENT_LANGUAGE: 'Content languages',
    CONTENT_LANGUAGE_INFO:
        'It is possible to select more than one language. Changes will be reflected in items, lists, courses and programs. <b>Attention:</b> content will only appear in the selected language(s).',
    WORKSHOP_TYPE: 'Type of workshop',
    WORKSHOP_TYPE_ONLINE: 'Online',
    WORKSHOP_TYPE_IN_PERSON: 'Class attendance',
    WORKSHOP_CLASS_PERIOD: 'Date and time',
    WORKSHOP_CHOOSE_START_DATE: 'Date',
    WORKSHOP_CHOOSE_START_TIME: 'Start time',
    WORKSHOP_CHOOSE_END_TIME: 'End time',
    WORKSHOP_SELECTED_START_TIME: 'Start time',
    WORKSHOP_SELECTED_END_TIME: 'End time',
    WORKSHOP_ADDRESS: 'Address',
    WORKSHOP_ADDRESS_PLACEHOLDER: 'Enter the address where the workshop will take place',
    WORKSHOP_URL: 'Virtual room link',
    WORKSHOP_URL_PLACEHOLDER: 'Enter the link to join the workshop room',
    WORKSHOP_INFORMATION: 'Informations',
    WORKSHOP_INSTRUCTOR: 'Who will lead the workshop',
    WORKSHOP_INSTRUCTOR_PLACEHOLDER: 'Enter instructor name',
    WORKSHOP_TIME: 'Workload: ',
    WORKSHOP_TIPS_INFO: 'Extra information for the workshop',
    WORKSHOP_TIPS_ALERT: 'Insert brief instructions. <b>Example</b>: Take your personal computer to participate in the dynamics.',
    WORKSHOP_ADD_TIPS_TITLE: 'Add one information',
    WORKSHOP_TIPS_PLACEHOLDER: 'Enter information',
    BRAZILIA_TIME: 'Brasilia Time',
    WORKSHOP_LINK: '<b>Room link:</b>',
    DETERMINE_THE_CLASS_PERIOD: 'You need to determine the class period and the day on which the workshop will take place. </br> Check an example:',
    WORKSHOP_MODAL_CALENDAR:
        '<b>Please note: </b> the day <b>of the workshop</b> needs to be scheduled from the <b>start date of the class and before the end date</b> (if determined).',
    WORKSHOP_UNDERSTAND_DEADLINES: 'About the deadlines',
    WORKSHOP_MINISTERED_BY: '<b>Ministered by:</b>',
    WORKSHOP_CHECK_OUT_SOME_EXTRA_INFO: 'Check out some extra information for the workshop:',
    WORKSHOP_WITH_CERTIFICATE: 'Workshop with certificate',
    CLASSES_TIPS_ALERT:
        'When you enroll or unenroll someone, the system automatically records the action. It is not necessary to click the <b>Save</b> button.',

    ENROLLMENT_ITEM_ERRORS: {
        SUCCESS: 'Success.',
        ALREADY_ENROLLED_IN_THE_CLASS: 'Already enrolled in the class.',
        ALREADY_ENROLLED_IN_ANOTHER_CLASS: 'Enrolled in another class.',
        INVALID_EMAIL: 'Invalid email format.',
        PERSON_NOT_FOUND: 'User not found.',
        INACTIVE_USER: 'Inactive user.',
    },
    WORKSHOP_ADD_NEW_MEETING_DAY: 'Add one more meeting',
    WORKSHOP_MEETING_DAY_NUMBER: '{0}º meeting',
    AT: 'At',
    IN: 'In',
    TRAINING_PAGE: {
        MENU: 'Trainings',
        TITLE: 'Check here for all the trainings you have been enrolled.',
        DYNAMIC_TITLE: 'Programs and courses',
    },
    SET_UP_WORKSHOP: 'Set up workshop',
    WORKSHOPS_WITH_CONFLICT: 'Some workshop schedules are in conflict. Click <strong>Edit</strong> to verify the information.',
    SET_UP: 'Set up',
    WORKSHOP_BEFORE_ANOTHER: 'This workshop is scheduled to take place before the workshop <b>%s</b>.',
    WORKSHOP_SAME_DAY_AND_HOUR_ANOTHER: 'This workshop is scheduled for the same day and time as the workshop <b>%s</b>.',
    SOON: 'Soon',
    INSERT_INVALID_LINK: 'Insert a valid link.',

    GO_TO_APP_OR_STORE_TITLE: "You're almost there!",
    GO_TO_APP_OR_STORE_DESCRIPTION: 'Download the platform for a complete learning experience!',
    LOGO_OF_COMPANY: 'Logo of company',
    SCORM_CONFIRM_BACK_DIALOG: {
        TITLE: 'Save your progress data',
        CONTENT: 'Before you leave, you need to save your progress information.',
        BUTTON_LABEL: 'Save',
    },
    QUESTIONS_SHOWN_IN_THE_ASSESSMENT: 'Questions shown in the assessment',
    DEFINE_NUMBER_OF_QUESTIONS:
        'Define how many questions will be shown to whoever answers the assessment. If you define a smaller number of questions than the total amount of questions registered, they will be displayed randomly.',
    ACCESS: 'Access',
    NEXT_LESSON: 'Next lesson',
    GO_TO_LESSONS: 'Go to lessons',
    AMOUNT_REGISTERED_QUESTIONS: '%n/%t registered questions.',
    DO_YOU_WANT_TO_CONFIGURE_NOW: 'Do you want to configure them now?',
    PROGRAM_WITH_NEW_WORKSHOP_WARNING: 'The program has received 1 or more new workshops, and they need to be set up in each class.',
    WORKSHOP_NOT_CONFIGURED: 'There are 1 or more unconfigured workshops in this class.',
    WORKSHOP_PUBLISHED: 'Workshop has been published!',
    ATTENTION_WORKSHOP_PUBLISHED:
        'It can be part of programs or be available separately. Do you want to add a class now and make the workshop available separately?',
    CONTENT_FAMILY: 'Content family',
    SELECT_CONTENT_FAMILY: 'Select a content family',
    DOCUMENT: 'Document',
    CONFIRM_DOCUMENT_DOWNLOAD: 'To complete this lesson it is necessary to download the file. Do you wish to continue?',
    SELECT_MULTIPLE_CHOICE_QUESTION_TYPE: 'Select multiple choice question type:',
    ONE_CORRECT_ANSWER: 'One correct answer',
    MULTIPLE_CORRECT_ANSWERS: 'Multiple correct answers',
    YOU_HAVE_SELECTED_ALL_ALTERNATIVES: 'You have selected all alternatives.',
    ADD_THE_ALTERNATIVES_AND_SELECT_THE_CORRECT_ONE: 'Add the alternatives and select the correct one:',
    ADD_THE_ALTERNATIVES_AND_SELECT_THE_CORRECT_ONES: 'Add the alternatives and select the correct ones:',
    WILL_REMOVE_THE_TARGET_AUDIENCE: 'Do you really want to exclude the target audience?',
    WHEN_DELETING_ENROLLED_USERS_THEY_WILL_NOT_BE_UNENROLLED: 'When deleting previously enrolled users, they will not be unenrolled.',
    TARGET_NAME: 'Target Audience Name',
    GROUP_EDIT: 'Group edit',
    CREATE_GROUP: 'Create group',
    GROUP_REGISTRATION: 'Target Audience Registration',
    CREATE_GROUP_SUCCESS: 'Create group successfully!',
    RULE: 'Rule',
    CREATE_GROUP_ERROR: 'Error creating Target Audience',
    GROUP_LIST: 'List of Target Audiences',
    MANAGER_GROUP: 'Manage Target Audience',
    EMPTY_GROUP: 'You dont have Target Audience rules created yet!',
    GROUP_EDIT_SUCCESS: 'Target audience successfully edited',
    FIRST_NAME: 'First name',
    GROUP_EDIT_ERROR: 'Error editing target audience',
    LAST_NAME: 'Last name',
    DEPARTAMENT_NAME: 'Departament',
    INPUT: 'Field',
    AND: 'And',
    OR: 'Or',
    CRITERIA: 'Criteria',
    EQUAL: 'Its equal',
    CONTAINS: 'Contains',
    ADD_CONDITION: 'Add condition',
    CREATE_RULE: 'Create Rule',
    EDIT_MADE_TO_RULE_CAN_ENROLL_NEW_USERS_BUT_DOES_NOT_ENENROLL_ENROLLED_USERS:
        'Edits made to the rule can enroll new users, but do not unenroll previously enrolled users',
    NAME_PUBLIC: 'Audience name',
    CONDITION: 'Conditions',
    SELECTED_PUBLIC_TARGET: 'Selected target audience ',
    PUBLIC_TARGET: 'Target audience',
    AUTOMATIC_ENROLL: 'Automatic enroll',
    PUBLIC_ACTIVATED_IN_CLASS: 'Public(s) activated in class',
    PUBLIC_ADDED_TO_CLASS: 'Public added to class',
    PUBLIC_REMOVE_CLASS: 'Public removed in the class',
} as LocaleData;
